// Path: ./src/app/components/NavigationBar/TopNavBar.tsx
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";

import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import goFlyerLogo from "../../assets/GoFlyer_Logo_2022Feb-10.png";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { LanguageGroupButton } from "../LanguageGroupButton";
import styled from "styled-components";
import UserDetailDropdown from "../UserDetailDropdown/UserDetailDropdown";

interface Props {
  window?: () => Window;
  isLoggedIn?: boolean;
}
const drawerWidth = 240;

export default function DrawerAppBar(props: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { window, isLoggedIn } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  /**
   * Open and Close SideDrawer in Mobile view
   * It's SideDrawer Of sign In, Sign Out etc
   */
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  /**
   * Handles navigation to a specific value.
   * @param value - The value to navigate to.
   */
  const handleNavigate = (value: string) => {
    navigate(value);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        sx={{
          my: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <img
          src={goFlyerLogo}
          style={{
            height: "50px",
          }}
        ></img>
      </Box>
      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          alignContent: "start",
          mt: 1,
          rowGap: "20px",
        }}
      >
        <LanguageButtonWrapper>
          {" "}
          <LanguageGroupButton />
        </LanguageButtonWrapper>
        {isLoggedIn ? (
          <>{isLoggedIn && <UserDetailDropdown />}</>
        ) : (
          <>
            <Button
              startIcon={
                <PersonIcon sx={{ color: "#f38321", padding: "0px" }} />
              }
              sx={{ color: "#272727", textTransform: "capitalize" }}
              onClick={() => {
                handleNavigate("login");
              }}
              data-testid="top-nav-sign-in-button"
            >
              {t(messages.Sign_In())}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }} data-testid="drawerappbar-test-id">
      <CssBaseline />
      <AppBar
        component="nav"
        style={{
          boxShadow: "0px 0px 8px #f3c49d",
        }}
      >
        <Toolbar
          style={{
            backgroundColor: "#f1f1f1",
            paddingTop: "6px",
            paddingBottom: "6px",
            justifyContent: "end",
            alignItems: "center",
            borderBottom: "2px solid #f3c49d",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" }, color: "#f38321" }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", sm: "block" },
              position: { xs: "absolute", sm: "relative" },
              left: {
                xs: "50%",
                sm: "0%",
              },
              transform: {
                xs: "translate(-50%, 0)",
                sm: "none",
              },
            }}
          >
            <img
              onClick={() => {
                handleNavigate("/");
              }}
              data-testid="top-nav-goflyer-home"
              src={goFlyerLogo}
              style={{
                height: "50px",
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
              alt="GoFlyer Logo"
            />
          </Box>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <LanguageButtonWrapper>
              <LanguageGroupButton />
            </LanguageButtonWrapper>
          </Box>

          {isLoggedIn ? (
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {isLoggedIn && <UserDetailDropdown />}
            </Box>
          ) : (
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Button
                startIcon={
                  <PersonIcon sx={{ color: "#f38321", padding: "0px" }} />
                }
                sx={{ color: "#272727", textTransform: "capitalize" }}
                onClick={() => {
                  handleNavigate("login");
                }}
                data-testid="top-nav-sign-in-button"
              >
                {t(messages.Sign_In())}
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          anchor="right"
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

const LanguageButtonWrapper = styled.div`
  margin-right: 10px;
`;
